import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=506934c0&scoped=true"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"
import style0 from "./DateField.vue?vue&type=style&index=0&id=506934c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506934c0",
  null
  
)

export default component.exports